import * as React from 'react';

import LearningPathBreadcrumbTrail from 'bundles/enterprise-learning-path-description-page/modules/LearningPathBreadcrumbTrail';

type Props = {
  orgSlug: string;
};

const EnterpriseOrgScopedLearningPathBreadcrumbs = ({ orgSlug }: Props) => {
  return <LearningPathBreadcrumbTrail orgSlug={orgSlug} />;
};

export default EnterpriseOrgScopedLearningPathBreadcrumbs;
